import React, { useEffect, useRef } from 'react';
import styled, { css } from 'styled-components';
import TimeZoneConnected from '../../components/Common/TimeZone';

export function StyledWrapperRadioList({ children }) {
  const ref = useRef();
  useEffect(() => {
    setTimeout(() => {
      // trick to trigger react transition
      // we can not use visibility here due to it need to overwrite plugin
      if (ref.current) {
        const { current } = ref;
        const { style } = current;
        const { offsetHeight } = current;
        const height = 110;

        style.borderBottom = [offsetHeight, offsetHeight - 1].includes(height) ? '1px solid #d8dfe1' : '';
      }
    }, 1);
  }, []);

  return (
    <StyledWrapper ref={ref}>
      {children}
    </StyledWrapper>
  );
}

const StyledWrapper = styled.div`
  width: 100%;
  max-height: 110px;
  margin-top: 16px;
  padding: 0;
  overflow-y: auto;
  scrollbar-color: #DEDEDE #EEEEEE;
  scrollbar-width: thin;
  &::-webkit-scrollbar {
  width: 6px;
  height: 6px;
}
  &::-webkit-scrollbar-thumb {
    border-radius: 10px;
    background-color: #DEDEDE;
  }
  &::-webkit-scrollbar-track {
    border-radius: 10px;
    background-color: #EEEEEE;
  }
  &::-webkit-scrollbar-thumb:hover {
    background-color: #C6C6C6;
  }
  &::-webkit-scrollbar-thumb:active {
    background-color: #8A8A8A;
  }
  & > ul {
    margin: 0;
    padding: 0;
    transition: all 0.4s cubic-bezier(0.11, 0.35, 0.57, 0.95);
    list-style-type: none;
  }
  & > ul > li {
    margin-bottom: 3px;
    border-radius: 3px;
    box-sizing: border-box;
    border: 1px solid #d8dfe1;
    padding: 5px 0;
    cursor: pointer;
    &:last-of-type {
      margin-bottom: 0;
    }
  }
`;

export const StyledTimeZone = styled(TimeZoneConnected)`
  margin-top: 10px;
  text-align: left;
`;

export const StyledGlobalWrapper = styled.div`${
  (props) => {
    const { styles } = props;
    const {
      color,
      inputsLabelsTextAlign,
      inputsBorderRadius,
      calendarBorderRadius,
      calendarCellsBorderRadius,
      buttonsBorderRadius,
    } = styles.body || {};

    const {
      padding: containerPadding,
      margin: containerMargin,
      widgetContainerBorderRadius
    } = styles.container || {};

    return css`
      input, select, textarea {
        border-radius: ${inputsBorderRadius}px !important;
      }
      
      button {
        border-radius: ${buttonsBorderRadius}px !important;
      }

      .rdp-head {
        .rdp-head_row {
          border-radius: ${calendarBorderRadius}px;
        }
      }
      
      .rdp-cell {
        button.rdp-button {
          border-radius: ${calendarCellsBorderRadius}px !important;
        }
      }

      .styled-select {
        .bta-react-select__control {
          border-radius: ${inputsBorderRadius}px;
        }
        span[class$="indicatorSeparator"] {
          background-color: ${color};
        }
        svg[class$="Svg"] {
          color: ${color};
        }
      }
      .locations-select, .resources-select, .variant-select {
        .titles {
          display: inline-block;
          width: 100%;
          text-align: ${inputsLabelsTextAlign};
        }
      }  
      .time-slot-radio-button-list-element {
        border-radius: ${inputsLabelsTextAlign}px;   
      }
      .sub-panel {
        border-radius: ${widgetContainerBorderRadius}px;
        padding: ${containerPadding}px;
        margin: ${containerMargin}px;
      }
    `;
  }
}`;
